import { Box, Grid, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import FillHistoryGrid from './components/FillHistoryGrid';
import SearchFillHistory from './components/FillHistorySearch';
import FillHistoryUpdateReportFillterButton from './components/FillHistoryUpdateReportFilterButton';
import FillHistoryUpdateReportTable from './components/FillHistoryUpdateReportTable';
import { FillHistorySearchProvider } from './hooks/useFillHistorySearch';
import { FillHistoryUpdateReportProvider } from './hooks/useFillHistoryUpdateReport';

const TabPanel = ({ children, value, currentTab }) => {
  const hidden = value !== currentTab;

  return (
    <div
      role='tabpanel'
      hidden={hidden}
      id={`FillHistoryNdcUpdate-tabpanel-${value}`}
      aria-labelledby={`FillHistoryNdcUpdates-tab-${value}`}
    >
      <Box sx={{ py: 3, px: 3 }}>{children}</Box>
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  currentTab: PropTypes.number.isRequired,
};

const a11yProps = (index) => ({
  id: `FillHistoryNdcUpdate-tab-${index}`,
  'aria-controls': `FillHistoryNdcUpdate-tabpanel-${index}`,
});

const FillHistory = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_, newValue) => setCurrentTab(newValue);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label='Ndc Update Tabs'>
          <Tab label='Bulk Update NDC' {...a11yProps(0)} />
          <Tab label='Update History' {...a11yProps(1)} />
        </Tabs>
      </Box>

      <TabPanel value={0} currentTab={currentTab}>
        <FillHistorySearchProvider>
          <Grid container direction='column' rowSpacing={2}>
            <Grid item container>
              <SearchFillHistory />
            </Grid>

            <Grid item>
              <FillHistoryGrid />
            </Grid>
          </Grid>
        </FillHistorySearchProvider>
      </TabPanel>

      <TabPanel value={1} currentTab={currentTab}>
        <FillHistoryUpdateReportProvider>
          <Grid container direction='column' rowSpacing={1}>
            <Grid item container direction='row-reverse'>
              <FillHistoryUpdateReportFillterButton />
            </Grid>

            <Grid item>
              <FillHistoryUpdateReportTable />
            </Grid>
          </Grid>
        </FillHistoryUpdateReportProvider>
      </TabPanel>
    </Box>
  );
};

export default FillHistory;
